import { render, staticRenderFns } from "./personnelOverview_coordinatorEvaluation.vue?vue&type=template&id=22c6585b&scoped=true&"
import script from "./personnelOverview_coordinatorEvaluation.vue?vue&type=script&lang=js&"
export * from "./personnelOverview_coordinatorEvaluation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c6585b",
  null
  
)

export default component.exports